import React, { useState, useRef, useCallback } from "react";
import { createPortal } from "react-dom";

const styles = {
  container: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 0,
  },
  tooltipText: (visible) => ({
    position: "fixed",
    visibility: visible ? "visible" : "hidden",
    opacity: visible ? 1 : 0,
    minWidth: "75px",
    backgroundColor: "#555",
    color: "#fff",
    textAlign: "center",
    padding: "5px 0",
    borderRadius: "6px",
    fontSize: "x-small",
    transition: "opacity 0.3s",
    pointerEvents: "none",
    zIndex: 999999,
  }),
  arrow: {
    content: '""',
    position: "absolute",
    bottom: "100%",
    left: "50%",
    marginLeft: "-5px",
    borderWidth: "5px",
    borderStyle: "solid",
    borderColor: "transparent transparent #555 transparent",
  },
};

export default function Tooltip({ text, children, width = 75 }) {
  const [hovered, setHovered] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);

  const updatePosition = useCallback(() => {
    if (!triggerRef.current) return;
    const rect = triggerRef.current.getBoundingClientRect();
    setCoords({
      top: rect.bottom + 8,
      left: rect.left + rect.width / 2,
    });
  }, []);

  const handleMouseEnter = () => {
    updatePosition();
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
    <span
      ref={triggerRef}
      style={styles.container}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}

      {createPortal(
        <div
          style={{
            ...styles.tooltipText(hovered),
            top: `${coords.top}px`,
            left: `${coords.left}px`,
            minWidth: `${width}px`,
            padding: "5px 5px",
            transform: "translateX(-50%)",
          }}
        >
          {text}
          <div style={styles.arrow} />
        </div>,
        document.body
      )}
    </span>
  );
}